import React from "react";

import { forwardRef, HStack, StackProps, Text } from "@chakra-ui/react";

export const DrawerListItem = forwardRef<StackProps, "div">(({ children, ...props }, ref) => {
  return (
    <HStack h={10} textColor="inherit" textDecoration="none" {...props} ref={ref}>
      <Text fontSize="sm">{children}</Text>
    </HStack>
  );
});
